<template>
  <div class="customer">
    <div class="customer-header">
      <h1>客户服务</h1>
    </div>
    <!-- <v-container class="pa-0 pb-5" style="background-color: #f7f7f7;">
      <v-layout column align-center justify-center class="customer-title">
        <h2>全程管家式服务</h2>
        <p>出险安心理赔，解决企业与员工的后顾之忧</p>
      </v-layout>
      <v-layout row wrap>
        <v-flex d-flex xs6 md3 justify-center fill-height v-for="item in service" :key="item.src">
          <v-img :src="item.src"></v-img>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="customer-container  app-bg">
      <v-container class="pa-0">
        <v-layout row justify-center>
          <v-flex sm6 md4 class="des des-right text-md-right text-sm-right text-xs-right">
            <i></i>
            <h3>个性化定制</h3>
            <p>根据企业实际情况，量身定做保障产品</p>
            <div class="con2_contast">
              <router-link to="/about#contact">如需定制，请联系我们 ></router-link>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md6 mt-4 d-flex justify-center class="service-img">
            <v-img src="/images/service/con2.png"></v-img>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="customer-container customer-bg app-bg">
      <v-container class="pa-0">
        <v-layout row justify-center>
          <v-flex xs12 sm12 md6 mt-4>
            <v-img src="/images/service/con3.png"></v-img>
          </v-flex>
          <v-flex  sm6 md4 class="des des-left text-md-left text-sm-left">
            <i></i>
            <h3>紧急医疗金先行垫付</h3>
            <p>解决企业与员工的燃眉之急</p>
          </v-flex>
        </v-layout>
      </v-container>
    </div> -->
    <div class="customer-container  app-bg">
      <v-container class="pa-0">
        <v-layout row justify-center>
          <section class="section">
            <h2 class="mb-4">客户服务及投诉渠道</h2>
            <div class="contact">
              <p>投保、理赔、保全服务及投诉电话：4006-234-345</p>
              <p class="contact-email">投诉邮箱：ycbxjj@chinatalentgroup.com</p>
              <p>承保公司服务渠道 </p>
              <p>详参信息披露模块合作保险公司及机构披露页的展示链接</p>
              <!-- <v-img
                max-height="200px"
                contain
                src="https://qihuibao.oss-cn-beijing.aliyuncs.com/company/kfwx.png"
              ></v-img> -->
            </div>
          </section>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        service: [
          {
            src: "/images/service/con1_1.png"
          },
          {
            src: "/images/service/con1_2.png"
          },
          {
            src: "/images/service/con1_3.png"
          },
          {
            src: "/images/service/con1_4.png"
          }
        ]
      };
    }
  };
</script>
<style lang="scss">
  .customer{
    .customer-header {
      width: 100%;
      height: 377px;
      background: url("/images//service/banner.png") no-repeat center center;
      background-size: cover;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      h1 {
        font-size: 40px;
        font-weight: 500;
        color: #fff;
      }
    }
    .customer-title{
      h2 {
        font-size: 36px;
        margin-bottom: 15px;
        font-weight: 400;
        padding-top: 60px;
      }

      p {
        font-size: 18px;
        color: #666666;
        margin-bottom: 40px;
      }
    }
    .customer-container{
      padding: 74px 0  58px;
      .des{
        box-shadow: 0px 0px 10px #ccc;
        padding:35px  0  50px;
        z-index: 1;
        background-color: #fff;
        position: relative;
        height: 297px;
        i{
          width: 98px;
          height: 3px;
          background-color: #DD122A;
          display: inline-block;
          margin-bottom: 48px;
        }
        h3{
          font-size: 36px;
          margin-bottom: 26px;
          font-weight: 400;
        }
        p{
          color: #666;
          font-size: 18px;
          margin-bottom: 26px;
        }
        a{
          border: 1px solid #DD122A;
          padding: 13px;
        }
      }
      .section {
        max-width: 900px;
        margin: 2em auto 0;
        padding: 15px;
        h2 {
          text-align: center;
          font-size: 36px;
        }
      }
    }
    .customer-bg{
      width: 100%;
      height: 100%;
      background: url("/images/service/bg.png") no-repeat center center;
      background-size: cover;
    }
    .des-right{
      padding-right: 50px !important;
      margin-right: -160px;
    }
    .des-left{
      padding-left: 50px !important;
      margin-left: -160px;
    }
  }
  @media screen and (max-width: 960px) {
      .service-img{
         position: relative;
      }
      .des{
         position: static;
         padding: 20px 0 30px;
        i{
          width: 45px;
          height: 3px;
          background-color: #DD122A;
          display: inline-block;
          margin-bottom: 30px!important;
        }
        h3{
          font-size: 28px!important;
          margin-bottom: 26px;
          font-weight: 400;
        }
        p{
          color: #666;
          font-size: 14px!important;
          margin-bottom: 26px;
        }
        a{
          border: 1px solid #DD122A;
          padding: 10px !important;
        }
      }
    .des-right{
      padding-right: 50px !important;
      margin-right: -65% !important;
    }
    .des-left{
      padding-left: 50px !important;
      margin-left: -65%!important;
    }
  }
  @media screen and (max-width: 600px) {
    .customer-header{
      h1{
        font-size: 28px !important;
      }
    }
    .customer-title {
      h2 {
        font-size: 26px!important;
        margin-bottom: 18px;
        font-weight: 400;
      }

      p {
        font-size: 14px!important;
        color: #666666;
        margin-bottom: 10px!important;
      }
      h3{
        font-size:20px!important;
      }
    }
    .customer-container{
      .des{
        position: static;
        padding: 27px !important;
        height: 190px!important;
        i{
          width: 20px;
          height: 3px;
          background-color: #DD122A;
          display: inline-block;
          margin-bottom: 30px!important;
        }
        h3{
          font-size: 18px!important;
          margin-bottom: 20px!important;
          font-weight: 400;
        }
        p{
          color: #666;
          font-size: 12px!important;
          margin-bottom: 10px !important;
        }
        a{
          border: 1px solid #DD122A;
          padding: 1px !important;
          font-size: 14px;
        }
      }
      .des-right{
        padding-right: 10px !important;
        margin-right: -65%!important;
        margin-left: 10px!important;
      }
      .des-left{
        padding-left: 10px !important;
        margin-left: -65%!important;
        margin-right: 10px!important;
      }
    }
  }
</style>